import { FormControl, Modal, Table, TableBody, TableCell, TableHead, TableRow, TextField } from '@mui/material';
import useAuthz from 'hooks/useAuthz';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useNavigate } from 'react-router';
import MyButton from '../../components/Layout/MyButton';
import axios from 'axios';
import { URL_API } from '../../utils/globalConfig';
import { downloadFile } from '../../utils/downloadHelper';
import {
  faCheck,
  faFileContract,
  faFileDownload,
  faFileExport,
  faFileUpload,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import MyComboBox from '../../components/Layout/MyComboBox';
import TopBar from '../../components/Layout/TopBar';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { ClipLoader } from 'react-spinners';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import * as PropTypes from 'prop-types';
import FacturationTable from '../../components/Facturation/FacturationTable';
import { logError } from '../../components/Utils/FormatData';
import MyLoader from '../../components/Layout/MyLoader';
import { FACTURATION_TYPE, PARAMETER, PROFIL, REQUEST_PASS_STATUS, TRJT_TYPE } from '../../constants/enum';
import MyCurrencyInput from '../../components/Layout/MyCurrencyInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons';
import ModalEditDevis from './ModalEditDevis';

const css = {
  container: { maxHeight: '90%', maxWidth: '90%', minWidth: '65%', minHeight: '30%', backgroundColor: 'white', borderRadius: '5px', overflow: 'auto' },
  devisContainer: { display: 'flex', flexDirection: 'column', maxHeight: '94%', minHeight: '30vh', position: 'relative' },
  overlayLoading: { display: 'flex', flexDirection: 'column', height: '94%' },
  fullRow: { display: 'flex', height: '100%', width: '100%', alignItems: 'center', justifyContent: 'center' },
  row: { height: 'calc(100% - 110px)', flexDirection: 'column', justifyContent: 'normal' },
  rowCost: {
    display: 'flex',
    width: '100%',
    height: 'auto',
    alignItems: 'center',
  },
  rowSelectedFolder: {
    overflow: 'visible',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    margin: '20px',
  },
  rowValidation: {
    justifyContent: 'flex-end',
    alignContent: 'flex-end',
    alignItems: 'center',
    height: '80px',
    margin: '10px',
  },
  rowSecondary: {
    display: 'flex',
    height: 'auto',
    width: '100%',
    justifyContent: 'space-arround',
    alignItems: 'center',
  },
  rowItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '30%',
  },
  formControl: { width: '100%', margin: '0' },
  tableHead: { border: '1px solid #4db4da', backgroundColor: '#0094ca' },
  textField: { width: '50%', margin: '20px' },
  textFieldShort: { width: '25%', margin: '20px' },
  textFieldFixed: { maxWidth: '200px', margin: '20px' },
  rowIntoPaper: { maxHeight: '100px', alignItems: 'center' },
  sectionPaper: { width: 'calc(100% - 20px)', padding: '0 0 40px 20px', margin: '15px' },
  sectionLibelle: { padding: '15px', textTransform: 'uppercase', fontFamily: 'Gadugi' },
  listItem: { marginBottom: '10px', fontSize: '16px' },
  contractBtn: {
    color: 'rgb(255, 255, 255)',
    height: '95%',
    backgroundColor: '#0094CA',
    width: '20%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '10px',
    cursor: 'pointer',
  },
  contractBtnIcon: { fontSize: '50px' },
  contractBtnLabel: {
    textAlign: 'center', textDecoration: 'none', fontSize: 14, fontWeight: 700, margin: '10px', cursor: 'pointer',
  },
  rowLabel: {
    fontSize: '20px',
    marginBottom: '20px',
    padding: '5px',
    paddingLeft: '40px',
    marginTop: '5px',
    marginLeft: '12px',
    borderBottomLeftRadius: '50px',
    boxShadow: 'rgba(0, 148, 202, 0.4) 0px 3px 4px',
  },
};

const DEVIS_TABS = {
  DEVIS: 'devis',
  DOSSIER: 'dossier',
  DOSSIER_PS: 'dossier_ps',
  DOSSIER_PA: 'dossier_pa',
  GENERATION: 'generation',
};

function BlobProvider(props) {
  return null;
}

BlobProvider.propTypes = { document: PropTypes.any };

const ModalCreateOrEditDevis = (props) => {
  const { openModal, setOpenModal, color, facturation_id, dossier_id, setReloadData, duplication } = props;
  const alert = useAlert();
  const navigate = useNavigate();
  const [authz, user, profil] = useAuthz();
  const [isLoading, setIsLoading] = useState(false);
  const [overlayLoading, setOverlayLoading] = useState(false);
  const [listeDossier, setListeDossier] = useState([]);
  const [dossier, setDossier] = useState(null);
  const [idSelectedDossier, setIdSelectedDossier] = useState(null);
  const [devis, setDevis] = useState(null);
  const [readOnly, setReadOnly] = useState(false);
  const [documentId, setDocumentId] = useState(null);
  const [etatDevis, setEtatDevis] = useState({
    statutDevis: null,
    description: null,
    numDossier: null,
    departement: null,
    refCommande: null,
    pdfAvailable: null,
    sapSent: null,
  });
  const [lines, setLines] = useState([]);
  const [newline, setNewline] = useState({ newTarif: null });
  const [totalAmount, setTotalAmount] = useState(devis && devis.montant || 0);
  const [tab, setTab] = useState(facturation_id ? DEVIS_TABS.DEVIS : DEVIS_TABS.DOSSIER);
  const [unitCostParam, setUnitCostParam] = useState(null);
  const [kmCostParam, setKmCostParam] = useState(null);
  const [gridCostParam, setGridCostParam] = useState(null);
  const [fraisDossierPS, setFraisDossierPS] = useState({
    nbConfigs: 0,
    nbSlices: 0,
    unitCost: 0,
    cost: 0,
  });
  const [fraisDossierPA, setFraisDossierPA] = useState({
    mileAgeAller: 0,
    mileAgeRetour: 0,
    nbCrossingsAller: 0,
    nbCrossingsRetour: 0,
    mileageCorrected: 0,
    kmCostAller: 0,
    kmCostRetour: 0,
    nbVehiclesAller: 1,
    nbVehiclesRetour: 1,
    forfait: 0,
    total: 0,
    costAller: 0,
    costRetour: 0,
    costForfait: 0
  });
  const [fraisDossierCalc, setFraisDossierCalc] = useState({
    quantite: 1,
    libelle: 'Etude, traitement et suivi du dossier',
    tarif: 0,
    unite: 'Forfait',
    description: 'Etude, traitement et suivi du dossier',
    code_comptable: '60084'
  });
  const [client, setClient] = useState({
    accepted: null,
    comment: '',
    orderNumber: '',
  });
  const [grilleTarifaire, setGrilleTarifaire] = useState([]);
  const [openModal1, setOpenModal1] = useState(false);

  //#region useEffect
  useEffect(() => {
    if (openModal) {
      if (profil.profil === 6) {
        alert.error(`Vous n'êtes pas autorisé à accéder à la ${duplication ? 'duplication' : 'création'} de devis`);
        navigate('/');
      } else {
        document.title = duplication ? `TE - Duplication d'un devis` : facturation_id ? `TE - Edition d'un devis` : `TE - Création d'un devis`;
        apiLoadRequestPassList();
      }
      if (facturation_id) {
        apiLoadQuotationByFactureId(facturation_id);
        setTab(DEVIS_TABS.DEVIS);
      }
      if (dossier_id) {
        setIdSelectedDossier(dossier_id);
      }

      apiGetAllParameters();
      apiLoadTarifsList();
    } else {
      setLines([]);
    }
  }, [openModal]);

  useEffect(() => {
    if (devis) {
      apiLoadTarifsList();
      setDossier(devis.dossier);
      setFraisDossierCalc({ ...fraisDossierCalc, tarif: devis.elements_factures.firstLine?.tarif });
    }
  }, [devis]);

  useEffect(() => {
    if (idSelectedDossier !== null && !facturation_id) {
      axios({ method: 'get', url: `${URL_API}/demande-passage/recuperer-demande`, params: { id: idSelectedDossier } })
        .then((response) => {
          setDossier(response.data);
        })
        .catch((error) => {
          logError(alert, error);
        });
    } else {
      setDossier(null);
    }
  }, [idSelectedDossier]);

  useEffect(() => {
    if (dossier) {
      let metadata = dossier.metadata;

      // Chargement des données du dossier pour les frais de dossier PS
      setFraisDossierPS({ ...fraisDossierPS, nbConfigs: metadata.caracConvoi.configurations?.length });

      // Chargement des données du dossier pour les frais de dossier PA
      let datePassage = metadata.datePassage;
      let trajetDescr = metadata.trajetDescr;


      let nbCrossingsAller = datePassage.nbPassageAller;
      let nbCrossingsRetour = datePassage.nbPassageRetour;

      let nbVehiclesAller = datePassage.nbVehiculeAller;
      let nbVehiclesRetour = datePassage.nbVehiculeRetour;

      let mileAgeAller = 0;
      let mileAgeRetour = 0;

      trajetDescr.descr?.map((descr) => {
        if (descr.passType === 'superieur') return;
        mileAgeAller += Math.abs(descr.prSectionExit - descr.prSectionEnter);
      });

      trajetDescr.descrRetour?.map((descr) => {
        if (descr.passType === 'superieur') return;
        mileAgeRetour += Math.abs(descr.prSectionExit - descr.prSectionEnter);
      });

      mileAgeAller = parseFloat(mileAgeAller).toFixed(4);
      mileAgeRetour = parseFloat(mileAgeRetour).toFixed(4);

      setFraisDossierPA({ ...fraisDossierPA, nbCrossingsAller, nbCrossingsRetour, nbVehiclesAller, nbVehiclesRetour, mileAgeAller, mileAgeRetour });

      apiCheckDocument();
    }
  }, [dossier]);

  useEffect(() => {
    if (unitCostParam)
      setFraisDossierPS({ ...fraisDossierPS, unitCost: unitCostParam.value });
  }, [unitCostParam]);

  useEffect(() => {
    if (kmCostParam)
      setFraisDossierPA({ ...fraisDossierPA, kmCostAller: Number(kmCostParam.value), kmCostRetour: Number(kmCostParam.value) });
  }, [kmCostParam]);

  useEffect(() => {
    if (fraisDossierPS.nbConfigs !== '')
      setFraisDossierPS({ ...fraisDossierPS, nbSlices: Math.ceil(fraisDossierPS.nbConfigs / 5) });
  }, [fraisDossierPS.nbConfigs]);

  useEffect(() => {
    let cost = 0;

    if (fraisDossierPS.nbConfigs !== '') {
      let unitCost = fraisDossierPS.unitCost;
      cost = fraisDossierPS.nbSlices * unitCost;
    }

    setFraisDossierPS({ ...fraisDossierPS, cost: cost });

  }, [fraisDossierPS.nbSlices, fraisDossierPS.unitCost]);

  useEffect(() => {
    calculatePACost();
  }, [fraisDossierPA.nbCrossingsAller, fraisDossierPA.nbCrossingsRetour, fraisDossierPA.nbVehiclesAller, fraisDossierPA.nbVehiclesRetour, fraisDossierPA.mileAgeAller, fraisDossierPA.mileAgeRetour, fraisDossierPA.mileageCorrected, fraisDossierPA.kmCostAller, fraisDossierPA.kmCostRetour]);

  //#endregion

  //#region Functions
  const calculatePACost = () => {
    let costAller = 0;
    let costRetour = 0;
    let costForfait = 0;
    let total = 0;
    let nbCrossingsAller = Number(fraisDossierPA.nbCrossingsAller);
    let nbCrossingsRetour = Number(fraisDossierPA.nbCrossingsRetour);
    let nbVehiclesAller = Number(fraisDossierPA.nbVehiclesAller);
    let nbVehiclesRetour = Number(fraisDossierPA.nbVehiclesRetour);
    let kmCostAller = fraisDossierPA.kmCostAller;
    let kmCostRetour = fraisDossierPA.kmCostRetour;
    let mileAgeAller = parseFloat(fraisDossierPA.mileAgeAller);
    let mileAgeRetour = parseFloat(fraisDossierPA.mileAgeRetour);

    if ((nbCrossingsAller && mileAgeAller && kmCostAller) || (nbCrossingsRetour && mileAgeRetour && kmCostRetour)) {
      let costObjectAller;
      if (mileAgeAller <= 100) {
        costObjectAller = gridCostParam.find(item => item.km === "< 100");
      } else if (mileAgeAller <= 200) {
        costObjectAller = gridCostParam.find(item => item.km === "< 200");
      } else if (mileAgeAller >= 200) {
        costObjectAller = gridCostParam.find(item => item.km === "200 et +");
      }

      let costObjectRetour;
      if (mileAgeRetour <= 100) {
        costObjectRetour = gridCostParam.find(item => item.km === "< 100");
      } else if (mileAgeRetour <= 200) {
        costObjectRetour = gridCostParam.find(item => item.km === "< 200");
      } else if (mileAgeRetour >= 200) {
        costObjectRetour = gridCostParam.find(item => item.km === "200 et +");
      }

      let costObjectForfait;
      if ((mileAgeAller) <= 100) {
        costObjectForfait = gridCostParam.find(item => item.km === "< 100");
      } else if ((mileAgeAller) <= 200) {
        costObjectForfait = gridCostParam.find(item => item.km === "< 200");
      } else if ((mileAgeAller) >= 200) {
        costObjectForfait = gridCostParam.find(item => item.km === "200 et +");
      }

      if (nbCrossingsAller === 1) {
        costAller = Number(costObjectAller['1']);
      } else if (nbCrossingsAller < 10) {
        costAller = Number(costObjectAller['<10']);
      } else if (nbCrossingsAller < 20) {
        costAller = Number(costObjectAller['<20']);
      } else if (nbCrossingsAller >= 20) {
        let k = (Number(fraisDossierPA.nbCrossingsAller) * Number(fraisDossierPA.nbVehiclesAller) * parseFloat(fraisDossierPA.mileAgeAller) * fraisDossierPA.kmCostAller);
        costAller = Number(costObjectAller['20 et +'].replace(' + K', '')) + k;
      }

      if (nbCrossingsRetour === 1) {
        costRetour = Number(costObjectRetour['1']);
      } else if (nbCrossingsAller < 10) {
        costRetour = Number(costObjectRetour['<10']);
      } else if (nbCrossingsAller < 20) {
        costRetour = Number(costObjectRetour['<20']);
      } else if (nbCrossingsAller >= 20) {
        let k = (Number(fraisDossierPA.nbCrossingsRetour) * Number(fraisDossierPA.nbVehiclesRetour) * parseFloat(fraisDossierPA.mileAgeRetour) * fraisDossierPA.kmCostRetour);
        costRetour = Number(costObjectRetour['20 et +'].replace(' + K', '')) + k;
      }

      let calculForfaitCrossings = (Number(fraisDossierPA.nbCrossingsAller) * Number(fraisDossierPA.nbVehiclesAller)) + (Number(fraisDossierPA.nbCrossingsRetour) * Number(fraisDossierPA.nbVehiclesRetour));
      if (calculForfaitCrossings === 1) {
        costForfait = Number(costObjectForfait['1']);
      } else if (calculForfaitCrossings < 10) {
        costForfait = Number(costObjectForfait['<10']);
      } else if (calculForfaitCrossings < 20) {
        costForfait = Number(costObjectForfait['<20']);
      } else if (calculForfaitCrossings >= 20) {
        costForfait = Number(costObjectForfait['20 et +'].replace(' + K', ''));
        let k = ((Number(fraisDossierPA.kmCostAller) * parseFloat(fraisDossierPA.mileAgeAller) * Number(fraisDossierPA.nbCrossingsAller) * Number(fraisDossierPA.nbVehiclesAller)) + (Number(fraisDossierPA.kmCostRetour) * parseFloat(fraisDossierPA.mileAgeRetour) * Number(fraisDossierPA.nbCrossingsRetour) * Number(fraisDossierPA.nbVehiclesRetour)))
        total = costForfait + k;
      }

      setFraisDossierPA({ ...fraisDossierPA, costAller: costAller, costRetour: costRetour, forfait: costForfait, total: total !== 0 ? total.toFixed(2) : costForfait.toFixed(2) });
    }
  }

  const handleCloseModal = () => {
    setIdSelectedDossier(null);
    setIsLoading(false);
    setOpenModal(false);
    setTab(DEVIS_TABS.DOSSIER);
  };

  // Changement des valeurs du dossier
  const handleChange = (e, data, setData, pattern) => {
      let calculForfaitCrossings = (Number(fraisDossierPA.nbCrossingsAller) * Number(fraisDossierPA.nbVehiclesAller)) + (Number(fraisDossierPA.nbCrossingsRetour) * Number(fraisDossierPA.nbVehiclesRetour));
     let total = Number(e.target.value);
     if (calculForfaitCrossings >= 20) {
        let k = ((Number(fraisDossierPA.kmCostAller) * parseFloat(fraisDossierPA.mileAgeAller) * Number(fraisDossierPA.nbCrossingsAller) * Number(fraisDossierPA.nbVehiclesAller)) + (Number(fraisDossierPA.kmCostRetour) * parseFloat(fraisDossierPA.mileAgeRetour) * Number(fraisDossierPA.nbCrossingsRetour) * Number(fraisDossierPA.nbVehiclesRetour)));
        total = Number(e.target.value) + k;
        total = total.toFixed(2);
    }
    if (e.target.name === 'forfait') {
     setFraisDossierPA({ ...fraisDossierPA, total: total, forfait: Number(e.target.value) });
     return
    }
    if (e.target.value === '' || new RegExp(pattern).test(e.target.value)) {
      setData({ ...data, [e.target.name]: e.target.value, total: total });
    }
  };

  const handleSaveQuotation = () => {
    let newlines = [];
    let additionalLines = [];

    setOverlayLoading(true);

    lines.forEach((objTarif, i) => {
      if (objTarif.quantite > 0) {
        if (objTarif.tarif_id) {
          newlines.push({
            id_tarif: objTarif.tarif_id,
            quantite: objTarif.quantite,
            libelle: objTarif.libelle,
            tarif: objTarif.tarif,
            unite: objTarif.unite,
            description: objTarif.description,
            centre: objTarif.centre,
            mesures_exploit: objTarif.mesures_exploit,
            code_comptable: objTarif.code_comptable !== '' ? objTarif.code_comptable : profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE ? '60084' : '60081'
          });
        } else {
          additionalLines.push({
            quantite: objTarif.quantite,
            libelle: objTarif.libelle,
            tarif: objTarif.tarif,
            unite: objTarif.unite,
            description: objTarif.description,
            centre: objTarif.centre,
            mesures_exploit: objTarif.mesures_exploit,
            code_comptable: objTarif.code_comptable !== '' ? objTarif.code_comptable : profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE ? '60084' : '60081'
          });
        }
      }
    });

    apiSaveQuotation({
      elements_factures: {
        devis: [],
        client: client,
        status: etatDevis,
        firstLine: fraisDossierCalc,
        lines: newlines,
        additionalLines: additionalLines,
      },
      type_facturation: 'devis',
      deleted: false,
      user_id: dossier.user_id,
      dossier_id: duplication ? dossier.id : facturation_id ? devis.dossier_id : dossier.id,
      montant: totalAmount,
    });
  };

  const handleSendDevis = () => {
    apiSendQuotationNotification();
  };

  const onValidateCostBtnClick = (type) => {
    if (type === "PA")
      setFraisDossierCalc({ ...fraisDossierCalc, tarif: Number(fraisDossierPA.total).toFixed(2) });

    if (type === "PS")
      setFraisDossierCalc({ ...fraisDossierCalc, tarif: fraisDossierPS.cost });

    alert.removeAll();
    alert.success('Le montant a bien été calculé');
  };

  const onRequestPassContractBtnClick = () => {
    navigate('/facturation/' + devis.type_facturation + '?id=' + facturation_id);
  };
  //#endregion

  //#region API
  const apiSaveQuotation = (estimate) => {
    axios({
      method: 'post',
      url: `${URL_API}/facturation/save`,
      data: estimate,
      params: { userAction: user.user_id, id: duplication ? null : facturation_id },
    })
      .then((response) => {
        setOpenModal(false);

        if (response.data && (profil.profil === 1 || profil.profil === 2 || profil.profil === 3)) {
          alert.removeAll();
          alert.success('Le devis a bien été enregistré !');
        }

        setOverlayLoading(false);
        setReloadData(true);
      })
      .catch((error) => {
        logError(alert, error);
        setOverlayLoading(false);
      });
  };

  const apiSendQuotationNotification = () => {
    setOverlayLoading(true);

    axios({
      method: 'post',
      url: `${URL_API}/facturation/send-quotation`,
      params: { requestPassId: devis.dossier_id, userAction: user.user_id },
    })
      .then((response) => {
        setOverlayLoading(false);

        if (response.data && (profil.profil === 1 || profil.profil === 2)) {
          alert.removeAll();
          alert.success('La notification a bien été envoyée!');
        }

      })
      .catch((error) => {
        logError(alert, error);
        setOverlayLoading(false);
      });
  };

  const apiLoadRequestPassList = () => {
    const promiseListSuperieur = axios({
      method: 'post', url: `${URL_API}/demande-passage/liste`, data: {
        type: 'superieur',
        hubs: [],
      },
    });
    const promiseListAutoroute = axios({
      method: 'post', url: `${URL_API}/demande-passage/liste`, data: {
        type: 'autoroute',
        hubs: [],
      },
    });

    Promise.all([promiseListSuperieur, promiseListAutoroute])
      .then((response) => {
        let listDossier = [];
        let status = [REQUEST_PASS_STATUS.VALIDATED, REQUEST_PASS_STATUS.SENT, REQUEST_PASS_STATUS.SIGNED, REQUEST_PASS_STATUS.ACCEPTED];
        response[0].data.forEach((e) => {
          if (status.includes(e.id_status)) listDossier.push((e.id).toString());
        }); // récupération des dossiers validés uniquement
        response[1].data.forEach((e) => {
          if (status.includes(e.id_status)) listDossier.push((e.id).toString());
        });
        setListeDossier(listDossier);
      })
      .catch((error) => {
        alert.removeAll();
        alert.error(error.message);
      });
  };
  const apiLoadQuotationByFactureId = () => {
    axios({ method: 'get', url: `${URL_API}/facturation/fact-by-id`, params: { id: facturation_id } })
      .then((response) => {
        let data = response.data;

        if (duplication) {
          data.elements_factures.status.departement = null;
          data.elements_factures.status.description = null;
          data.elements_factures.status.numDossier = null;
          data.elements_factures.status.pdfAvailable = null;
          data.elements_factures.status.sapSent = null;
          data.elements_factures.status.refCommande = null;
          data.elements_factures.status.statutDevis = null;
          data.elements_factures.returnDate = null;
          data.elements_factures.creationDate = null;
        }

        setReadOnly(profil.profil === PROFIL.INTERVENANT || (data.elements_factures.status.pdfAvailable === true && data.elements_factures.returnDate !== null));
        setDevis(data);
        setEtatDevis(data.elements_factures.status);
      })
      .catch((error) => {
        alert.removeAll();
        alert.error(error.message);
      });
  };
  const apiLoadTarifsList = () => {
    axios({
      method: 'get',
      url: `${URL_API}/grille-tarifaire/full-list`,
      params: { deleted: false, userAction: user.user_id },
    })
      .then((response) => {
        let priceList = response.data;

        // Ajout d'une colonne quantité à 0 et selected à false par défaut pour chaque ligne
        priceList.forEach((tarif) => {
          tarif.quantite = 1;
          tarif.selected = false;
        });

        // Ajustements des quantités via les lignes présentes sur le devis
        if (devis) {
          setLines([...devis.elements_factures.lines, ...devis.elements_factures.additionalLines ?? []]);
        }

        // Màj des lignes à afficher sur le devis
        setGrilleTarifaire(priceList);
      })
      .catch((error) => {
        logError(alert, error);
      });
  };

  const apiGetAllParameters = () => {
    Promise.all([
      apiGetParameter(PARAMETER.COUT_UNITAIRE),
      apiGetParameter(PARAMETER.COUT_KM_PA),
      apiGetParameter(PARAMETER.COST)
    ]).then((res) => {
      if (!res[0].data || !res[1].data || !res[2].data) {
        alert.error('Des paramètres sont manquants en BDD');
        return false;
      }

      setUnitCostParam(res[0].data);
      setKmCostParam(res[1].data);
      setGridCostParam(res[2].data);

    }).catch((error) => {
      logError(alert, error);
      alert.error(error.message);
    });

  };

  const apiGetParameter = async (paramKey) => {
    return axios({ method: 'get', url: `${URL_API}/parameters/get-by-key`, params: { key: paramKey } });
  };

  const apiCheckDocument = () => {
    if (facturation_id && facturation_id !== 0 && !duplication) {
      axios({
        method: 'get',
        url: URL_API + '/facturation/verifier-document-facturation',
        params: { requestId: dossier.id, type: 'devis', facturationId: facturation_id },
      }).then((response) => {
        setDocumentId(response.data);
      }).catch((error) => {
        setIsLoading(false);
        logError(alert, error);
      });
    }
  };
  //#endregion

  return (
    <Modal open={openModal} style={{ display: 'flex' }} disableEscapeKeyDown={true}>
      <>
        {overlayLoading &&
          <MyLoader loading={overlayLoading} />
        }
        <div className='modal'>
          <div style={css.container}>
            <TopBar title={readOnly ? `Consultation du devis` : duplication ? `Duplication de devis` : facturation_id ? `Edition du devis [N°` + facturation_id + `]` : `Création d'un devis`}
                    className='topbar-contenu'
                    color={'#f18d2d'}
                    style={{
                      zIndex: '100'
                    }}
                    buttons={
                      <div className='topbar-buttons'>
                        {(profil.profil === 1 || profil.profil === 2) &&
                          <>
                            {!facturation_id &&
                              <MyButton onClick={() => setTab(DEVIS_TABS.DOSSIER)}
                                        style={tab === DEVIS_TABS.DOSSIER ? 'tabButtonDefaultSelected' : 'tabButtonDefault'}
                                        label='DOSSIER'
                                        sx={{backgroundColor: '#b76618 !important'}}
                              />}
                            {(!readOnly && (dossier || devis)) &&
                              <>
                                <MyButton onClick={() => setTab(DEVIS_TABS.DOSSIER_PS)}
                                          style={tab === DEVIS_TABS.DOSSIER_PS ? 'tabButtonDefaultSelected' : 'tabButtonDefault'}
                                          label='CALCUL FRAIS DE DOSSIER PS'
                                          sx={{backgroundColor: '#b76618 !important'}}
                                />
                                <MyButton onClick={() => setTab(DEVIS_TABS.DOSSIER_PA)}
                                          style={tab === DEVIS_TABS.DOSSIER_PA ? 'tabButtonDefaultSelected' : 'tabButtonDefault'}
                                          label='CALCUL FRAIS DE DOSSIER PA'
                                          sx={{backgroundColor: '#b76618 !important'}}
                                />
                              </>
                            }
                          </>
                        }

                        {(dossier || devis) &&
                          <MyButton onClick={() => setTab(DEVIS_TABS.DEVIS)}
                                    style={tab === DEVIS_TABS.DEVIS ? 'tabButtonDefaultSelected' : 'tabButtonDefault'}
                                    label={(profil.profil === 1 || profil.profil === 2 || profil.profil === 3) ? 'CONSTITUTION DU DEVIS' : 'RÉSUMÉ DU DEVIS'}
                                    sx={{backgroundColor: '#b76618 !important'}}
                          />}

                        {devis && !readOnly && (profil.profil === 1 || profil.profil === 2 || profil.profil === 5) &&
                          (dossier || devis) &&
                          <MyButton onClick={() => setTab(DEVIS_TABS.GENERATION)}
                                    style={tab === DEVIS_TABS.GENERATION ? 'tabButtonDefaultSelected' : 'tabButtonDefault'}
                                    sx={{backgroundColor: '#b76618 !important'}}
                                    label={profil.profil === 5 ? 'GERER LE DEVIS' : 'GENERER LE DEVIS'} />}

                        <MyButton onClick={() => handleCloseModal()} label='Fermer' icon={faXmark} sx={{backgroundColor: '#b76618 !important'}} />
                      </div>}
            />

            {/* LOADER */}
            {isLoading && <div className='row' style={css.fullRow}>
              <ClipLoader color='#0094ca' loading={isLoading} size={75}
                          css={'display: flex; margin: 25px;justify-content: center;'} />
            </div>}

            {/* CONTAINER */}
            {!isLoading &&
              <div style={{
                ...css.devisContainer,
                overflowY: 'auto',
                height: 'auto'
              }}>
                {tab === DEVIS_TABS.DOSSIER &&
                  <>
                    <div className='row' style={{
                      ...css.rowSelectedFolder,
                      alignContent: !facturation_id ? 'flex-start' : '',
                      maxHeight: '125px',
                    }}>
                      <FormControl>
                        <FormLabel>Sélectionner le dossier pour lequel vous souhaitez générer un devis :</FormLabel>
                        <MyComboBox label={'Dossier N°'}
                                    id={'selectedDossier'}
                                    options={listeDossier}
                                    setter={setIdSelectedDossier}
                                    value={idSelectedDossier}
                        />
                      </FormControl>
                    </div>
                  </>
                }

                {tab === DEVIS_TABS.DOSSIER_PS &&
                  <div style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}>
                    <div className='row' style={{ ...css.rowSecondary, justifyContent: 'center' }}>
                      {/*<MyButton onClick={() => false} label='CALCUL FRAIS de DOSSIER PS' />*/}
                    </div>
                    <div className='row' style={css.rowSecondary}>
                      <div style={css.rowItem}>
                        <TextField
                          label='NOMBRE DE CONFIGURATIONS'
                          type='text'
                          name='nbConfigs'
                          value={fraisDossierPS.nbConfigs}
                          style={{ ...css.textField, width: 'auto', flexGrow: 1 }}
                          disabled={readOnly}
                          autoComplete='off'
                          onChange={(e) => handleChange(e, fraisDossierPS, setFraisDossierPS, '^[0-9]*$')}
                          inputProps={{ maxLength: 3 }}
                        />
                      </div>
                      <div style={css.rowItem}>
                        <label>Soit: </label>
                        <TextField
                          label='NB TRANCHES'
                          type='text'
                          name='nbSlices'
                          value={fraisDossierPS.nbSlices}
                          style={{ ...css.textField, width: 'auto', flexGrow: 1 }}
                          disabled={readOnly}
                          autoComplete='off'
                          onChange={(e) => handleChange(e, fraisDossierPS, setFraisDossierPS, '^[0-9]*$')}
                          inputProps={{ maxLength: 3 }}
                        />
                      </div>
                      <div style={css.rowItem}></div>
                    </div>
                    <div className='row' style={css.rowSecondary}>
                      <div style={css.rowItem}></div>
                      <div style={css.rowItem}>
                        <TextField
                          label='COÛT UNITAIRE'
                          type='text'
                          name='unitCost'
                          value={fraisDossierPS.unitCost}
                          style={{ ...css.textField, width: 'auto', flexGrow: 1 }}
                          disabled={readOnly}
                          autoComplete='off'
                          onChange={(e) => handleChange(e, fraisDossierPS, setFraisDossierPS, '^[0-9]*$')}
                          inputProps={{ maxLength: 10 }}
                        />
                      </div>
                      <div style={css.rowItem}></div>
                    </div>
                    <div className='row' style={css.rowSecondary}>
                      <div style={css.rowItem}>
                        <label>Montant du forfait : </label>
                      </div>
                      <div style={css.rowItem}>
                        <TextField
                          label='COÛT (en €)'
                          type='text'
                          name='cost'
                          value={fraisDossierPS.cost}
                          style={{ ...css.textField, width: 'auto', flexGrow: 1 }}
                          disabled={readOnly}
                          autoComplete='off'
                          onChange={(e) => handleChange(e, fraisDossierPS, setFraisDossierPS, '^[0-9]*[.]?[0-9]{0,2}$')}
                        />
                      </div>
                      <div style={css.rowItem}></div>
                    </div>
                    <div className='row' style={css.rowSecondary}>
                      <div style={css.rowItem}></div>
                      <div style={css.rowItem}></div>
                      <div style={{
                        ...css.rowItem,
                        width: 'auto'
                      }}>
                        <MyButton disabled={readOnly} onClick={() => onValidateCostBtnClick("PS")} style={'buttonValidation'}
                                  label={'Valider le montant'} icon={faCheck} />
                      </div>
                    </div>
                  </div>
                }

                {tab === DEVIS_TABS.DOSSIER_PA &&
                    <div style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      gap: '50px'
                    }}>
                      <div style={{ width: '35%' }}>
                        <h3 style={{ textAlign: 'center' }}>ALLER</h3>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                          <TextField
                              label='NB DE DEMANDE DE PASSAGES'
                              type='text'
                              name='nbCrossingsAller'
                              value={fraisDossierPA.nbCrossingsAller}
                              style={{ width: '90%', flexGrow: 1 }}
                              disabled={readOnly}
                              autoComplete='off'
                              onChange={(e) => handleChange(e, fraisDossierPA, setFraisDossierPA, '^[0-9]*$')}
                              inputProps={{ maxLength: 3 }}
                          />
                          <TextField
                              label='NB DE VÉHICULES'
                              type='text'
                              name='nbVehiclesAller'
                              value={fraisDossierPA.nbVehiclesAller}
                              style={{ width: '90%', flexGrow: 1 }}
                              disabled={readOnly}
                              autoComplete='off'
                              onChange={(e) => handleChange(e, fraisDossierPA, setFraisDossierPA, '^[0-9]*$')}
                              inputProps={{ maxLength: 10 }}
                          />
                          <div style={{ display: 'flex', alignItems: 'center', width: '90%' }}>
                            <label>Soit :</label>
                            <TextField
                                label='NB DE PASSAGES'
                                type='text'
                                name='nbPassagesAller'
                                value={(Number(fraisDossierPA.nbCrossingsAller) * Number(fraisDossierPA.nbVehiclesAller))}
                                style={{ width: 'auto', flexGrow: 1 }}
                                disabled={true}
                                autoComplete='off'
                            />
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <TextField
                                label='KILOMÉTRAGE'
                                type='text'
                                name='mileAgeAller'
                                value={fraisDossierPA.mileAgeAller}
                                style={{ ...css.textField, width: '40%', flexGrow: 1 }}
                                disabled={readOnly}
                                autoComplete='off'
                                onChange={(e) => handleChange(e, fraisDossierPA, setFraisDossierPA, '^[0-9]*[.]?[0-9]{0,4}$')}
                            />
                            <TextField
                                label='COÛT DU KM'
                                type='text'
                                name='kmCostAller'
                                value={fraisDossierPA.kmCostAller}
                                style={{ ...css.textField, width: '40%', flexGrow: 1 }}
                                disabled={readOnly}
                                autoComplete='off'
                                onChange={(e) => handleChange(e, fraisDossierPA, setFraisDossierPA, '^[0-9]*[.]?[0-9]{0,10}$')}
                            />
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', width: '90%' }}>
                            <label>Soit :</label>
                            <TextField
                                label='COUT KM / PASSAGE'
                                type='text'
                                name='nbCostAller'
                                value={(Number(fraisDossierPA.kmCostAller) * parseFloat(fraisDossierPA.mileAgeAller)).toFixed(5)}
                                style={{ width: 'auto', flexGrow: 1 }}
                                disabled={true}
                                autoComplete='off'
                            />
                          </div>
                          <TextField
                              label='COUT KM ALLER'
                              type='text'
                              name='costTotalAller'
                              value={(Number(fraisDossierPA.kmCostAller) * parseFloat(fraisDossierPA.mileAgeAller) * Number(fraisDossierPA.nbCrossingsAller) * Number(fraisDossierPA.nbVehiclesAller)).toFixed(2)}
                              style={{ width: '90%', flexGrow: 1 }}
                              disabled={true}
                              autoComplete='off'
                          />
                        </div>
                      </div>

                      { (dossier && dossier.metadata.trajetDescr.type ? dossier.metadata.trajetDescr.type === TRJT_TYPE.ALLER_RETOUR : false) &&
                      <div style={{ width: '35%' }}>
                        <h3 style={{ textAlign: 'center' }}>RETOUR</h3>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                          <TextField
                              label='NB DE DEMANDE DE PASSAGES'
                              type='text'
                              name='nbCrossingsRetour'
                              value={fraisDossierPA.nbCrossingsRetour}
                              style={{ width: '90%', flexGrow: 1 }}
                              disabled={readOnly}
                              autoComplete='off'
                              onChange={(e) => handleChange(e, fraisDossierPA, setFraisDossierPA, '^[0-9]*$')}
                              inputProps={{ maxLength: 3 }}
                          />
                          <TextField
                              label='NB DE VÉHICULES'
                              type='text'
                              name='nbVehiclesRetour'
                              value={fraisDossierPA.nbVehiclesRetour}
                              style={{ width: '90%', flexGrow: 1 }}
                              disabled={readOnly}
                              autoComplete='off'
                              onChange={(e) => handleChange(e, fraisDossierPA, setFraisDossierPA, '^[0-9]*$')}
                              inputProps={{ maxLength: 10 }}
                          />
                          <div style={{ display: 'flex', alignItems: 'center', width: '90%' }}>
                            <label>Soit :</label>
                            <TextField
                                label='NB DE PASSAGES'
                                type='text'
                                name='nbPassagesRetour'
                                value={(Number(fraisDossierPA.nbCrossingsRetour) * Number(fraisDossierPA.nbVehiclesRetour))}
                                style={{ width: 'auto', flexGrow: 1 }}
                                disabled={true}
                                autoComplete='off'
                            />
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <TextField
                                label='KILOMÉTRAGE'
                                type='text'
                                name='mileAgeRetour'
                                value={fraisDossierPA.mileAgeRetour}
                                style={{ ...css.textField, width: '40%', flexGrow: 1 }}
                                autoComplete='off'
                                onChange={(e) => handleChange(e, fraisDossierPA, setFraisDossierPA, '^[0-9]*[.]?[0-9]{0,4}$')}
                            />
                            <TextField
                                label='COÛT DU KM'
                                type='text'
                                name='kmCostRetour'
                                value={fraisDossierPA.kmCostRetour}
                                style={{ ...css.textField, width: '40%', flexGrow: 1 }}
                                disabled={readOnly}
                                autoComplete='off'
                                onChange={(e) => handleChange(e, fraisDossierPA, setFraisDossierPA, '^[0-9]*[.]?[0-9]{0,10}$')}
                            />
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', width: '90%' }}>
                            <label>Soit :</label>
                            <TextField
                                label='COUT KM / PASSAGE'
                                type='text'
                                name='nbCostRetour'
                                value={(Number(fraisDossierPA.kmCostRetour) * parseFloat(fraisDossierPA.mileAgeRetour)).toFixed(5)}
                                style={{ width: 'auto', flexGrow: 1 }}
                                disabled={true}
                                autoComplete='off'
                            />
                          </div>
                          <TextField
                              label='COUT KM RETOUR'
                              type='text'
                              name='costTotalRetour'
                              value={(Number(fraisDossierPA.kmCostRetour) * parseFloat(fraisDossierPA.mileAgeRetour) * Number(fraisDossierPA.nbCrossingsRetour) * Number(fraisDossierPA.nbVehiclesRetour)).toFixed(2)}
                              style={{ width: '90%', flexGrow: 1 }}
                              disabled={true}
                              autoComplete='off'
                          />
                        </div>
                      </div>
                      }

                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        maxWidth: '30%',
                        width: '-webkit-fill-available',
                      }}>
                        <TextField
                            label='FORFAIT (Hors KM)'
                            type='text'
                            name='forfait'
                            value={fraisDossierPA.forfait}
                            style={{ ...css.textField, width: 'auto', flexGrow: 1 }}
                            onChange={(e) => handleChange(e, fraisDossierPA, setFraisDossierPA, '^[0-9]*[.]?[0-9]{0,2}$')}
                            disabled={readOnly}
                            autoComplete='off'
                        />


                        {(dossier && dossier.metadata.trajetDescr.type ? dossier.metadata.trajetDescr.type === TRJT_TYPE.ALLER_RETOUR ? (Number(fraisDossierPA.nbCrossingsAller) * Number(fraisDossierPA.nbVehiclesAller)) + (Number(fraisDossierPA.nbCrossingsRetour) * Number(fraisDossierPA.nbVehiclesRetour)) >= 20 : Number(fraisDossierPA.nbCrossingsAller) * Number(fraisDossierPA.nbVehiclesAller) >= 20 : false) &&
                          <TextField
                              label='COÛT KILOMETRIQUE (K)'
                              type='text'
                              name='costK'
                              value={((Number(fraisDossierPA.kmCostAller) * parseFloat(fraisDossierPA.mileAgeAller) * Number(fraisDossierPA.nbCrossingsAller) * Number(fraisDossierPA.nbVehiclesAller)) + (Number(fraisDossierPA.kmCostRetour) * parseFloat(fraisDossierPA.mileAgeRetour) * Number(fraisDossierPA.nbCrossingsRetour) * Number(fraisDossierPA.nbVehiclesRetour))).toFixed(2)}
                              style={{ ...css.textField, width: 'auto', flexGrow: 1 }}
                              disabled={readOnly}
                              autoComplete='off'
                              onChange={(e) => handleChange(e, fraisDossierPA, setFraisDossierPA, '^[0-9]*[.]?[0-9]{0,2}$')}
                          />
                        }

                        <label>Montant du forfait :</label>
                        <TextField
                            label='COÛT (en €)'
                            type='text'
                            name='total'
                            value={fraisDossierPA.total}
                            style={{ ...css.textField, width: 'auto', flexGrow: 1 }}
                            disabled={readOnly}
                            autoComplete='off'
                            onChange={(e) => handleChange(e, fraisDossierPA, setFraisDossierPA, '^[0-9]*[.]?[0-9]{0,2}$')}
                        />

                        <MyButton disabled={readOnly} onClick={() => onValidateCostBtnClick('PA')}
                                  style={'buttonValidation'}
                                  label={'Enregistrer'} icon={faCheck} />

                        <Table id='gridCost'>
                          <TableHead>
                            <TableRow>
                              <TableCell align='center' style={{ width: 'auto', fontWeight: 'bold' }}>KM
                                \ Nb passages</TableCell>
                              <TableCell align='center'
                                         style={{ width: 'auto', fontWeight: 'bold' }}>1</TableCell>
                              <TableCell align='center' style={{
                                width: 'auto',
                                fontWeight: 'bold',
                              }}>&lt;10</TableCell>
                              <TableCell align='center' style={{
                                width: 'auto',
                                fontWeight: 'bold',
                              }}>&lt;20</TableCell>
                              <TableCell align='center' style={{ width: 'auto', fontWeight: 'bold' }}>20
                                et +</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {gridCostParam.map((item) => (
                                <TableRow key={item.km}>
                                  <TableCell align='center'>{item.km}</TableCell>
                                  <TableCell align='center'>{item['1']}</TableCell>
                                  <TableCell align='center'>{item['<10']}</TableCell>
                                  <TableCell align='center'>{item['<20']}</TableCell>
                                  <TableCell align='center'>{item['20 et +']}</TableCell>
                                </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                        <p style={{width: 'auto'}}>Où K = (Nb de passages Aller x Nb de véhicules Aller x Kilométrage Aller x Coût du KM)
                          + (Nb de passages Retour x Nb de véhicules Retour x Kilométrage Retour x Coût du KM)</p>
                      </div>
                    </div>
                }

                {dossier && tab === DEVIS_TABS.DEVIS &&
                    <>
                      <div className='row' style={css.rowCost}>
                        <div style={{
                          width: '15%',
                          paddingLeft: '20px',
                        }}>{fraisDossierCalc.libelle}</div>
                        <div style={{
                          width: '66%',
                          marginRight: '-30px',
                        }}>
                          <hr />
                        </div>
                        <div style={{
                          width: '15%',
                          paddingLeft: '20px',
                          marginRight: '20px',
                        }}>
                          <TextField
                              label={fraisDossierCalc.unite}
                              type='text'
                              name='tarif'
                              value={fraisDossierCalc.tarif}
                              style={{ ...css.textField, width: 'auto', flexGrow: 1 }}
                              disabled={readOnly}
                              autoComplete='off'
                              onChange={(e) => handleChange(e, fraisDossierCalc, setFraisDossierCalc)}
                          />
                        </div>
                      </div>
                      <div className='row' style={{ height: 'auto' }}>
                        <FormControl style={css.formControl}>
                          <FacturationTable
                              dossier={devis}
                              listeDossier={listeDossier}
                              grilleTarifaire={grilleTarifaire}
                              lines={lines}
                              setLines={setLines}
                              newLine={newline}
                              setNewLine={setNewline}
                              firstLineAmount={Number(fraisDossierCalc.tarif)}
                              totalAmount={totalAmount}
                              setTotalAmount={setTotalAmount}
                              isFacture={false}
                          />
                        </FormControl>
                      </div>
                      {(!devis?.elements_factures.status.pdfAvailable && (profil.profil === 1 || profil.profil === 2 || profil.profil === 3)) &&
                          <>
                            <div className='row' style={css.rowValidation}>
                              <MyButton onClick={() => handleSaveQuotation()}
                                        style={'buttonValidation'}
                                        label={'Enregistrer'}
                                        icon={faCheck}
                              />
                            </div>
                          </>
                      }
                    </>
                }

                {devis && tab === DEVIS_TABS.GENERATION &&
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-around',
                      alignItems: 'center',
                      height: '92%',
                      width: '100%',
                      position: 'absolute',
                    }}>
                      <div style={css.fullRow}>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          width: '70%',
                          height: '80%',
                          justifyContent: 'space-around',
                          marginTop: 'calc(6vh + 5px)',
                        }}>
                          {(profil.profil === 1 || profil.profil === 2 && (etatDevis.statutDevis !== 'accepted' && etatDevis.statutDevis !== 'refused')) &&
                              <div className='icon-opacity' style={css.contractBtn}
                                   title={'Créer devis'}
                                   onClick={onRequestPassContractBtnClick}>
                                <FontAwesomeIcon style={css.contractBtnIcon} icon={faFilePdf} />
                                <label style={css.contractBtnLabel}>{'Créer'}</label>
                              </div>
                          }

                          {devis && documentId &&
                              <a className='icon-opacity' style={{...css.contractBtn, cursor: 'pointer'}}
                                 title={'Télécharger le devis'}
                                 onClick={() => downloadFile(URL_API + '/facturation/telecharger-document-facturation?requestId=' + devis.dossier.id + '&type=DEVIS' + '&facturationId=' + facturation_id)}>
                                <FontAwesomeIcon style={css.contractBtnIcon} icon={faFileDownload} />
                                <label style={css.contractBtnLabel}>Télécharger le devis</label>
                              </a>
                          }

                          {devis?.elements_factures.status.pdfAvailable && (profil.profil === 1 || profil.profil === 2 || profil.profil === 5) &&
                          <div className='icon-opacity' style={css.contractBtn}
                               title={'Accepter / Refuser le devis'}
                               onClick={() => setOpenModal1(true)}>
                            <FontAwesomeIcon style={css.contractBtnIcon} icon={faFileContract} />
                            <label style={css.contractBtnLabel}>{'Accepter / Refuser le devis'}</label>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
        {devis &&
          <ModalEditDevis
            openModal={openModal1}
            setOpenModal={setOpenModal1}
            color={'#0094ca'}
            user={user}
            facturation={devis}
            profil={profil}
            setReloadData={setReloadData}
          />
        }
      </>
    </Modal>
  );
};

export default ModalCreateOrEditDevis;
